import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "kebabCase",
  pure: false,
  standalone: true,
})
export class KebabCasePipe implements PipeTransform {
  transform(value: string): string {
    if (value == null) {
      return null;
    }
    return value
      .toString()
      .replace(/([a-z])([A-Z])/g, "$1-$2")
      .replace(/[ºª!¡@#%^&*:;,|¿?'"“”‘’.{}_~¬()/]/g, " ")
      .replace("$", "dolar")
      .replace("€", "euro")
      .replace("+", "mas-")
      .replace("/\s\s+/", "")
      .replace(/\s+/g, "-")
      .replace(/^-/, "")
      .replace(/-$/, "")
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "");
  }
}
